<div class="h-100 d-flex flex-column justify-content-between py-3 py-lg-0">
  <div>
    <div class="d-flex justify-content-between align-items-center mb-5" *ngIf="showSchoolLogo">
      <img src="../../../../../assets/img/logo/LF_logo-horizontal.svg" [routerLink]="[currentLanguage + '/']" alt="" class="logo pointer">
      <img src="{{ schoolLogo }}" alt="" *ngIf="schoolLogo" class="school_logo">
    </div>

    <h1 class="font-28 fw-bold lf-font" [innerHTML]="bigTitle | translate"></h1>
  </div>

  <!--     register part   -->
  <div class="d-flex flex-column gap-24">
    <h2 class="font-18 fw-bold lf-font mb-0" [innerHTML]="smallTitle | translate"></h2>
    <google-signin-butt id="google" class="position-relative btn btn-primary gsb p-0" [selectable]="showGoogleLogin"
      [isCliked]="isClicked" (click)="isClicked = !isClicked; isGoogleClick()"></google-signin-butt>
    <div class="d-flex justify-content-center align-items-center">
      <div class="border flex-grow-1"></div>
      <div class="px-4 lightGray2 fw-bold font-16" [innerHTML]="'COMMON.OR' | translate"></div>
      <div class="border flex-grow-1"></div>
    </div>
    <button class="btn btn-primary text-white w-100 py-2 fw-bold" (click)="open('register')"
      [innerHTML]="'REGISTRATION.CREATE_ACCOUNT' | translate"
      [title]="'REGISTRATION.CREATE_ACCOUNT' | translate"></button>
    <p class="font-12 semi-bold" [innerHTML]="'REGISTRATION.ACCEPT_CGU' | translate"></p>
  </div>

  <!--     login part   -->
  <div class="d-flex flex-column align-items-center justify-content-center gap-8 mt-4">
    <h6 class="fw-bold font-18" [innerHTML]="'REGISTRATION.LOGIN_TITLE' | translate"></h6>
    <div class="position-relative">
      <button class="btn border px-5 py-2 text-primary fw-bold bg-white border-2 transition025"
              (click)="open('login')" [innerHTML]="'COMMON.LOGIN' | translate"></button>
      <img src="../../../../../assets/img/randomBg/24px_round-grandient_rtoo.svg" alt="" class="register_asset position-absolute" *ngIf="showAsset">
    </div>
    <div class="position-relative">
      <div class="language-select m-3">
        <button (click)="useLanguage('en');flagToggle('en')" [ngClass]="grey == 'en' ?'bgGrey':''" class="link-language">
          <img src="./assets/img/seoHeaderImg/flag_en.webp" loading="lazy" alt="lang-en" class="image-60"></button>
        <button (click)="useLanguage('fr');flagToggle('fr')" [ngClass]="grey == 'fr' ?'bgGrey':''" class="link-language">
          <img src="./assets/img/seoHeaderImg/flag_fr.webp" loading="lazy" alt="lang-fr" class="image-60"></button>
      </div>
    </div>
  </div>

</div>
<!--------------------------------------------------- LOGIN MODAL ----------------------------------------------------->
<app-modale-login *ngIf="openedModal === 'login'" (isModalClosed)="open($event)" [returnUrl]="returnUrl"
                  [slug]="slug"></app-modale-login>
<!------------------------------------------------- REGISTER MODAL ---------------------------------------------------->
<app-modale-register *ngIf="openedModal === 'register'" (isModalClosed)="open($event)" [returnUrl]="returnUrl"
                     [school]="school" [slug]="slug" [oAuthUser]="oAuthUser" ></app-modale-register>
